module.exports = __webpack_public_path__ + "static/img/img_login_code.2a51ab53.png";